export default "__VITE_ASSET__CeVPUMAU__"